export const utwiit_info = 'Please join us in celebrating the release of it.bockwaterheaters.com — UTWI\'s new centralized website for all things IT!'

export const utwiit_md = `

# Announcing it.bockwaterheaters.com
*Last updated on July 21, 2025*

# Overview

Please join us in celebrating the release of it.bockwaterheaters.com — UTWI's new centralized website for all things IT!

This site currently offers an overview of some of the services we provide, a collection of request forms for you to fill out and submit to us, a section for news relating to our department, a page for cybersecurity advice, and a help page in case you need to contact us.

# Getting Started
- Want to learn about some of the services we offer? Check out the [Services](https://it.bockwaterheaters.com/#/services) page.
- Need to request something from us? Check out the [Forms](https://it.bockwaterheaters.com/#/forms) page.
- Interested in what's been going on in the department? Check out the [News](https://it.bockwaterheaters.com/#/news) page.
- Want some cybersecurity tips? Check out the [Cybersecurity](https://it.bockwaterheaters.com/#/cybersecurity) page.
- Do you need to contact us? Check out the [Help](https://it.bockwaterheaters.com/#/help) page.

`